const KEY = 'crm_objections';

export const DEFAULT_OBJECTIONS = [
  {
    id: 'obj_1',
    title: 'Kein Bedarf',
    response: 'Ich verstehe das vollkommen. Darf ich kurz fragen – welche Lösung nutzen Sie dafür gerade? Viele unserer Kunden aus Ihrer Branche haben am Anfang ähnlich gedacht, und erst im Gespräch gemerkt, wo konkret Potenzial liegt. Würden Sie mir 2 Minuten geben?',
    color: '#ef4444',
    branches: [],
  },
  {
    id: 'obj_2',
    title: 'Zu teuer',
    response: 'Das ist ein fairer Einwand – darf ich fragen, im Vergleich zu was? Was kostet Sie das Problem, wenn es ungelöst bleibt? Unsere Kunden im Handwerk berichten oft von deutlichen Mehreinnahmen im ersten Jahr. Wäre es sinnvoll, das kurz durchzurechnen?',
    color: '#f59e0b',
    branches: [],
  },
  {
    id: 'obj_3',
    title: 'Kein Budget gerade',
    response: 'Das verstehe ich – Budget ist immer ein Thema. Darf ich fragen: Wenn es kein Budgetthema wäre, wäre die Lösung grundsätzlich interessant für Sie? Dann können wir gemeinsam schauen, was realistisch machbar ist – wir haben flexible Modelle.',
    color: '#f97316',
    branches: [],
  },
  {
    id: 'obj_4',
    title: 'Schicken Sie uns Infos zu',
    response: 'Das mache ich gerne. Damit es nicht in der Inbox untergeht: Was interessiert Sie am meisten – der Ablauf, die Kosten oder konkrete Ergebnisse aus Ihrer Branche? Dann sende ich Ihnen genau das Richtige – und wir sprechen kurz dazu.',
    color: '#8f7cc9',
    branches: [],
  },
  {
    id: 'obj_5',
    title: 'Haben schon einen Anbieter',
    response: 'Das freut mich – dann sind Sie schon aktiv. Womit arbeiten Sie aktuell? Viele unserer Kunden haben vorher auch mit anderen Anbietern gearbeitet und sind gewechselt, weil sie mehr Resultate sehen wollten. Ein kurzer Vergleich – wäre das sinnvoll?',
    color: '#06b6d4',
    branches: [],
  },
  {
    id: 'obj_6',
    title: 'Jetzt gerade keine Zeit',
    response: 'Absolut verständlich – wann wäre ein besserer Moment für Sie? Ich reserviere gerne einen kurzen Termin für nächste Woche. Geht Ihnen Dienstag oder Donnerstag besser?',
    color: '#66796c',
    branches: [],
  },
  {
    id: 'obj_7',
    title: 'Muss den Chef / Partner fragen',
    response: 'Das ist verständlich. Wäre es möglich, das kurze Gespräch direkt mit Ihnen beiden zu führen? So hat Ihr Chef alle Infos aus erster Hand – und Sie sparen sich die interne Abstimmungsrunde. Wann wäre das möglich?',
    color: '#10b981',
    branches: [],
  },
  {
    id: 'obj_8',
    title: 'Zu wenig Branchenerfahrung',
    response: 'Ein wichtiger Punkt. Tatsächlich haben wir bereits mehrere Betriebe aus genau Ihrer Branche betreut. Darf ich Ihnen kurz zeigen, was die konkret erreicht haben? Dann können Sie selbst beurteilen, ob das zu Ihnen passt.',
    color: '#159c5f',
    branches: [],
  },
  {
    id: 'obj_9',
    title: 'Müssen uns das überlegen',
    response: 'Natürlich. Was genau würden Sie noch klären wollen? Oft kann ich im Gespräch direkt helfen – dann sparen Sie sich die interne Runde. Was ist Ihr größtes Fragezeichen?',
    color: '#a678cf',
    branches: [],
  },
];

export function loadObjections() {
  try {
    const s = localStorage.getItem(KEY);
    if (s) return JSON.parse(s);
  } catch {}
  return DEFAULT_OBJECTIONS.map(o => ({ ...o }));
}

export function saveObjections(list) {
  try { localStorage.setItem(KEY, JSON.stringify(list)); } catch {}
}
